import apiClient from "./apiClient";

// ✅ Fetch all pet finders with pagination
export const fetchPetFindersAPI = (page = 1) => {
  return apiClient.get(`/tailmission/api/v1/admin/pet_finders?page=${page}`);
};

// ✅ Fetch a single pet finder by ID
export const fetchPetFinderByIdAPI = (id) => {
  return apiClient.get(`/tailmission/api/v1/admin/pet_finders/${id}`);
};

// ✅ Delete a pet finder by ID
export const deletePetFinderAPI = (id) => {
  return apiClient.delete(`/tailmission/api/v1/admin/pet_finders/${id}`);
};

// ✅ Update a pet finder by ID
export const updatePetFinderAPI = (id, data) => {
  // Check if data is FormData (for proper backend format)
  const isFormData = data instanceof FormData;

  const config = {
    headers: {
      ...(isFormData && { 'Content-Type': 'multipart/form-data' })
    }
  };

  return apiClient.put(`/tailmission/api/v1/admin/pet_finders/${id}`, data, config);
};

// ✅ Create a new pet finder entry
export const createPetFinderAPI = (data) => {
  return apiClient.post(`/tailmission/api/v1/admin/pet_finders`, data);
};
